//USERINFO
const ultronUser = localStorage.getItem('ultron-user')
  ? JSON.parse(localStorage.getItem('ultron-user') || '')
  : null;

//SIGNIN
const ultronSignIn = localStorage.getItem('ultron-user-signIn')
  ? JSON.parse(localStorage.getItem('ultron-user-signIn') || '')
  : null;

//REGISTER
const ultronRegister = localStorage.getItem('ultron-user-register')
  ? JSON.parse(localStorage.getItem('ultron-user-register') || '')
  : null;

const referrerId = localStorage.getItem('refferalId')
  ? JSON.parse(localStorage.getItem('refferalId') || '')
  : null;

export const preloadedState = {
  userInfo: {
    ...ultronUser,
    referrerId: parseInt(referrerId)
  },

  register: {
    ...ultronRegister,
    referrerId: parseInt(ultronRegister?.referrerId)
  },

  signIn: {
    ...ultronSignIn
  }
};
